import { appointmentFields, parisInstant } from './appointment.js';
import { internalMeetingSpan, shiftDays } from './planning-week.js';
/**
 * Ce que le créneau occupe, en instants, fin exclue : sa durée pour un rendez-vous, ses journées
 * entières pour un point interne qui en compte (#670). `null` pour un instant illisible.
 */
export function occupiedRange(slot) {
    if (slot.teams !== undefined)
        return internalMeetingSpan(slot.scheduledAt, slot.durationMinutes);
    const start = Date.parse(slot.scheduledAt);
    return Number.isNaN(start) ? null : { start, end: start + slot.durationMinutes * 60_000 };
}
/** Le créneau occupe-t-il cette équipe ? Un rendez-vous abandonné ne l'occupe plus. */
export function occupiesTeam(slot, teamId) {
    return ((slot.team?.id === teamId || slot.teams?.some((crew) => crew.id === teamId) === true) &&
        slot.inquiry?.status !== 'dropped');
}
/**
 * L'heure de Paris (`HH:MM`) où l'équipe se libère le jour dit (#330) : la fin du dernier de ses
 * rendez-vous et points internes ce jour-là, durée comprise. C'est l'heure que les boîtes qui
 * posent un créneau proposent, pour que trois demandes planifiées de suite tombent à 8 h, 9 h,
 * 10 h sans rien retaper.
 *
 * ⚠️ **Un contrôle effectué garde son créneau** (recette du 20/10/2026) : le temps a été passé
 * là, quel que soit le statut de la demande. Seule une demande abandonnée (`dropped`) le rend.
 *
 * `null` quand l'équipe n'a rien ce jour-là — l'appelant propose alors son heure par défaut —, ou
 * quand ce qui l'occupe déborde sur le lendemain : il n'y a plus d'heure libre à proposer ce jour.
 * Un séminaire commencé la veille compte (#576) : c'est ce qui **chevauche** le jour qui l'occupe.
 */
export function nextFreeTime(occupied, teamId, day) {
    const midnight = parisInstant(day, '00:00');
    if (midnight === null)
        return null;
    const opens = Date.parse(midnight);
    const closes = Date.parse(parisInstant(shiftDays(day, 1), '00:00') ?? '');
    const ends = occupied
        .filter((slot) => occupiesTeam(slot, teamId))
        .flatMap((slot) => occupiedRange(slot) ?? [])
        .filter(({ start, end }) => start < closes && end > opens)
        .map(({ end }) => end);
    if (ends.length === 0)
        return null;
    const end = appointmentFields(new Date(Math.max(...ends)).toISOString());
    return end?.day === day ? end.time : null;
}
//# sourceMappingURL=next-free-time.js.map